import { useInstantSearch, useStats } from 'react-instantsearch';

interface AlgoliaLoadingStateProps {
  isLoading: boolean;
  isFirstLoading: boolean;
}

export const useAlgoliaLoadingState = (): AlgoliaLoadingStateProps => {
  const { status } = useInstantSearch();
  const { nbHits, processingTimeMS } = useStats();

  const isFirstLoading = status !== 'error' && nbHits === 0 && processingTimeMS === 0;
  const isLoading = status === 'loading' || status === 'stalled';

  return { isLoading, isFirstLoading };
};
